import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Page } from '../../Page';

export const RewardsPageSkeleton: FC = () => {
  return (
    <Page back insetEnabled={false}>
      <Stack direction="row" gap={0.5} alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <ThemedSkeleton variant="circular" width={28} height={28} />
        <ThemedSkeleton variant="text" width={40} height={34} />
      </Stack>

      <Stack alignItems="center">
        <ThemedSkeleton variant="text" width={120} height={50} />
      </Stack>
      <Stack gap={1.5} paddingLeft="10px" paddingRight="10px">
          {Array.from({ length: 5 }).map((_, i) => (
            <ThemedSkeleton key={i} variant="rectangular" width="100%" height={60} sx={{
                borderRadius: 2
            }} />
          ))}
        </Stack>
    </Page>
  );
};

